/**
 * Regra 3 da meta: TT e Renovação juntos viram Migração (Douglas 29/10/2026,
 * apresentação aprovada).
 *
 * "A meta = altas + fibra + TT e REN + TI = junto... ganha 50% de tudo que
 * teria de faturamento." A tela testa na ordem: regra 1 (tudo separado, 100%),
 * regra 2 (a fibra a mais valida a Renovação, 100%) e só então a regra 3: os
 * demais KPIs batidos e TT + Renovação somando a meta de TT + a meta de
 * Renovação. Paga `pct_meta_migracao_junta` (50%) da comissão; os descontos
 * (convergência, deflator do cancelado, eSIM) seguem iguais.
 *
 * No gestor, o TT e a Renovação desta conta são só das equipes que valem na
 * meta, sem a Diretoria (Douglas 29/10/2026: "para ajudar ela bater a meta de
 * migração não poderia entrar os da diretoria... seria injusto"). Nas regras 1
 * e 2 a Diretoria continua ajudando em tudo.
 *
 * Régua única dos três motores (tela, folha e Excel).
 */
export interface MetaMigracaoJunta {
  usar_meta_migracao_junta?: boolean | null;
  pct_meta_migracao_junta?: number | string | null;
}

export function fatorMigracaoJunta(regra: MetaMigracaoJunta | null | undefined): number {
  const pct = Number(regra?.pct_meta_migracao_junta ?? 50);
  return Math.min(100, Math.max(0, Number.isFinite(pct) ? pct : 50)) / 100;
}

export function metaMigracaoJunta(p: {
  usarTt: boolean;
  usarRenovacao: boolean;
  metaTt: number;
  metaRenovacao: number;
}): number {
  return (p.usarTt ? p.metaTt : 0) + (p.usarRenovacao ? p.metaRenovacao : 0);
}

export function metaBatidaPorMigracao(p: {
  regra: MetaMigracaoJunta | null | undefined;
  /** Passou pela regra 1 ou pela regra 2. */
  bateuSeparada: boolean;
  /** Todos os KPIs ligados, menos TT e Renovação, batidos. */
  bateuSemTtRenovacao: boolean;
  usarTt: boolean;
  usarRenovacao: boolean;
  /** TT e Renovação da conta da Migração (no gestor, sem a Diretoria). */
  tt: number;
  renovacao: number;
  metaTt: number;
  metaRenovacao: number;
}): boolean {
  if (!p.regra?.usar_meta_migracao_junta) return false;
  if (p.bateuSeparada || !p.bateuSemTtRenovacao) return false;
  if (!p.usarTt || !p.usarRenovacao) return false;
  return p.tt + p.renovacao >= metaMigracaoJunta(p);
}
